import { render, staticRenderFns } from "./PayFinished.vue?vue&type=template&id=07bcca00&scoped=true"
import script from "./PayFinished.vue?vue&type=script&lang=js"
export * from "./PayFinished.vue?vue&type=script&lang=js"
import style0 from "./PayFinished.vue?vue&type=style&index=0&id=07bcca00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bcca00",
  null
  
)

export default component.exports